export default function header() {
  return { Accept:'application/json','Access-Control-Allow-Origin':'https://fee.com.bd' };
}
